import { isPlainObject } from "./type-guards-DHLAzjf2.js";

//#region src/tools/catalog/support/api-formatting.ts
function formatId(value) {
	return value === void 0 || value === null ? "unknown" : String(value);
}
function formatDate(value) {
	if (!value) return null;
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return value;
	return date.toISOString();
}
function formatActor(value) {
	if (typeof value === "string") return value;
	if (!isPlainObject(value)) return "unknown";
	const name = value.name;
	if (typeof name === "string" && name.trim()) return name;
	const email = value.email;
	if (typeof email === "string" && email.trim()) return email;
	const username = value.username;
	if (typeof username === "string" && username.trim()) return username;
	return formatId(typeof value.id === "string" || typeof value.id === "number" ? value.id : void 0);
}
function formatUnknown(value) {
	if (value === null || value === void 0) return "unknown";
	if (typeof value === "string") return value;
	if (typeof value === "number" || typeof value === "boolean") return String(value);
	return JSON.stringify(value);
}
function readString(value, key) {
	if (!value) return null;
	const field = value[key];
	return typeof field === "string" && field.trim() ? field : null;
}
function compactLines(lines) {
	return lines.filter((line) => line !== null && line !== void 0 && line !== false);
}

//#endregion
export { compactLines, formatActor, formatDate, formatId, formatUnknown, readString };
//# sourceMappingURL=api-formatting-nIGXUFdx.js.map